module.exports = __webpack_public_path__ + "img/JAOC_POP_TomatoSauce_square.6eb82bbf.png";